const red = {
  200: "#F6CFD1",
  400: "#EEA0A4",
  900: "#D4111B",
  contrastDefaultColor: "#ffffff"
}
export default red
